import { render } from "./buyers.vue?vue&type=template&id=f6c50dbc&lang=pug"
import script from "./buyers.vue?vue&type=script&setup=true&lang=js"
export * from "./buyers.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__